import { useQuery } from '@tanstack/react-query';
import { apiClient } from '@/lib/api-client';
export function useMyAttendance(filters = {}) {
    return useQuery({
        queryKey: ['student-attendance', filters],
        queryFn: () => {
            const params = new URLSearchParams();
            if (filters.month)
                params.set('month', String(filters.month));
            if (filters.year)
                params.set('year', String(filters.year));
            const qs = params.toString();
            return apiClient(`/attendance/student/me${qs ? `?${qs}` : ''}`);
        },
        staleTime: 1000 * 60 * 3,
    });
}
//# sourceMappingURL=useMyAttendance.js.map